// ui imports
import MuiThemeProvider from "material-ui/styles/MuiThemeProvider";
import { ThemeProvider as MuiThemeProviderV4 } from "@material-ui/core/styles";
import HomeIcon from "material-ui/svg-icons/action/home";
import * as React from 'react';
// redux imports
import {connect, Dispatch} from 'react-redux';
// router imports
import {BrowserRouter as Router, Route} from 'react-router-dom';

import './App.css';
import AuthorizedRoute from './components/AuthorizedRoute';
// views/components imports
import GlobalTheme from './GlobalTheme';
import GlobalThemeV4 from './GlobalThemeV4';
import AdminView from "./views/AdminView/AdminView";
import ApprovalView from './views/ApprovalView/ApprovalView';
import BaseOptionsView from './views/BaseOptionsView/BaseOptionsView';
import LoginView from './views/LoginView';
import ModeltypeBasicView from './views/ModeltypeBasicView/ModeltypeBasicView';
import OptionsView from './views/OptionsView/OptionsView';
import StartView from "./views/MainView/StartView";
import SupportView from './views/SupportView/SupportView';
import TechnicalDataView from "./views/TechnicalDataView/TechnicalDataView";
import KumaView from './views/KumaView/KumaBasicView';
import BreadCrumbs from "./views/BreadCrumbs";
import {toast} from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import GeneralActions from "./redux/actions/GeneralActions";
import HATEOASClient from "./services/HATEOASClient";
import {MenuDto} from "./services/Client";
import {ILocationTranslation} from "./components/GeneralInterfaces";
import {selectBaseLinks, selectClient, selectLocationTranslations} from "./redux/selectors";
import {IReduxState} from "./redux/IReduxState";
import KumaManagementView from "./views/KumaView/KumaManagementView";
import Logout from "./views/Logout";
import ManagementView from "./views/ManagementView/ManagementView";
import MaintenanceStatus from "./views/MaintenanceStatus";
import GlobalContextMenu from "./components/GlobalContextMenu";
// create ToastContainer
toast.configure({
    position: "top-center",
    autoClose: false,
    closeOnClick: false,
    style: {
        top: "56px",
        left: "50%",
        transform: "translateX(-50%)",
        marginLeft: 0,
        width: "700px",
        draggablePercent: 50,
        zIndex: 999999,
    },
    toastClassName: "individual-toast",
});

interface IMapStateToProps {
    locationTranslations: ILocationTranslation[];
    client: HATEOASClient;
    baseLinks: MenuDto | undefined;
}

interface IMapDispatchToProps {
    AddTranslationLocation: () => void;
}

interface IApp extends IMapStateToProps, IMapDispatchToProps { }

const App: React.SFC<IApp> = ({
    client,
    locationTranslations,
    baseLinks,
    AddTranslationLocation
}) => {
    if (locationTranslations.length === 0) AddTranslationLocation();

    return (
        <MuiThemeProvider muiTheme={GlobalTheme}>
            <MuiThemeProviderV4 theme={GlobalThemeV4}>
            <GlobalContextMenu />
            <Router>
                <div className="main-container">
                    {sessionStorage.getItem("currentToken") !== null && <BreadCrumbs />}
                    <AuthorizedRoute
                        exact={true}
                        path="/"
                        component={StartView}
                        client={client}
                        from={{...location} as Location}
                    />
                    <AuthorizedRoute
                        exact={true}
                        path="/technicaldata/:modelyear?/:typefamily?/:cnr?/:derivate?"
                        component={TechnicalDataView}
                        client={client}
                        access={baseLinks ? [{
                            linkContainer: baseLinks,
                            requestNames: ["GET_technicalData"]
                        }] : undefined}
                    />
                    <AuthorizedRoute
                        exact={true}
                        path="/options/:modelyear?/:typefamily?/:cnr?"
                        component={OptionsView}
                        client={client}
                    />
                    <AuthorizedRoute
                        exact={true}
                        path="/admin"
                        component={AdminView}
                        client={client}
                        access={baseLinks ? [{
                            linkContainer: baseLinks,
                            requestNames: ["GET_adminArea"]
                        }] : undefined}
                    />
                    <AuthorizedRoute
                        path="/approval/:modelyear?/:typefamily?"
                        component={ApprovalView}
                        client={client}
                        access={baseLinks ? [{
                            linkContainer: baseLinks,
                            requestNames: ["GET_workflows"]
                        }] : undefined}
                    />
                    <AuthorizedRoute
                        path="/managementview"
                        component={ManagementView}
                        client={client}
                        access={baseLinks ? [{
                            linkContainer: baseLinks,
                            requestNames: ["GET_supportArea"]
                        }] : undefined}
                    />
                    <AuthorizedRoute
                        path="/optionbasic/:modelyear?"
                        component={BaseOptionsView}
                        client={client}
                    />
                    <AuthorizedRoute
                        path="/modeltypebasic/:modelyear?"
                        component={ModeltypeBasicView}
                        client={client}
                    />
                    <AuthorizedRoute
                        path="/support"
                        component={SupportView}
                        client={client}
                        access={baseLinks ? [{
                            linkContainer: baseLinks,
                            requestNames: ["GET_supportArea"]
                        }] : undefined}
                    />
                    <AuthorizedRoute
                        exact={true}
                        path="/kuma"
                        component={KumaView}
                        client={client}
                        access={baseLinks ? [{
                            linkContainer: baseLinks,
                            requestNames: ["GET_kumaArea"]
                        }] : undefined}
                    />
                    <AuthorizedRoute
                        exact={true}
                        path="/kuma/managementview"
                        component={KumaManagementView}
                        client={client}
                        access={baseLinks ? [{
                            linkContainer: baseLinks,
                            requestNames: ["GET_kumaManagement"]
                        }] : undefined}
                    />
                    <Route exact={true} path={"/maintenance"} component={MaintenanceStatus} />
                    <Route exact={true} path={"/login"} component={LoginView} />
                    <Route exact={true} path={"/logout"} component={Logout} />
                </div>
            </Router>
            </MuiThemeProviderV4>
        </MuiThemeProvider>
    );
};

const mapStateToProps = (state: IReduxState): IMapStateToProps => ({
    locationTranslations: selectLocationTranslations(state),
    client: selectClient(state),
    baseLinks: selectBaseLinks(state),
});

const mapDispatchToProps = (dispatch: Dispatch<IReduxState>): IMapDispatchToProps => ({
    AddTranslationLocation: () => dispatch(GeneralActions.AddTranslationLocation({
        pattern: new RegExp("\/"),
        substitutes: [{substitute: {text: "", icon: <HomeIcon style={{color: "#ffffff", marginRight: 10}} />}}]
    }))
});

export default connect<IMapStateToProps, IMapDispatchToProps>(mapStateToProps, mapDispatchToProps)(App);



// WEBPACK FOOTER //
// ./src/App.tsx